module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "small-title"
  }, [_vm._v("\n        Rediger dine oplysninger\n    ")]), _vm._v(" "), _c('form', {
    staticClass: "create-user",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "hidden",
      "type": "text",
      "autocomplete": "off"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('label', [_vm._v("Navn *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$auth.user().name),
      expression: "$auth.user().name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Navn"
    },
    domProps: {
      "value": (_vm.$auth.user().name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$auth.user(), "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('label', [_vm._v("Brugerrolle")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px",
      "line-height": "40px"
    }
  }, [(_vm.$auth.user().roles[0].name === 'super-admin') ? _c('span', [_vm._v("Super Admin")]) : _vm._e(), _vm._v(" "), (_vm.$auth.user().roles[0].name === 'admin') ? _c('span', [_vm._v("Administrator")]) : _vm._e(), _vm._v(" "), (_vm.$auth.user().roles[0].name === 'user') ? _c('span', [_vm._v("Bruger")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "email"
  }, [_c('label', [_vm._v("E-mail *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$auth.user().email),
      expression: "$auth.user().email"
    }],
    attrs: {
      "type": "email",
      "name": "iufbw379fb",
      "placeholder": "E-mail"
    },
    domProps: {
      "value": (_vm.$auth.user().email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$auth.user(), "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "password"
  }, [_c('label', [_vm._v("Ny adgangskode *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.new_password),
      expression: "user.new_password"
    }],
    attrs: {
      "type": "password",
      "autocomplete": "new-password",
      "placeholder": "Ny adgangskode"
    },
    domProps: {
      "value": (_vm.user.new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "new_password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("Min. 8 karakterer (udfyldes kun hvis du vil skifte adgangskode)")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "action",
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "pretty-button",
    on: {
      "click": function($event) {
        return _vm.updateUser()
      }
    }
  }, [_vm._v("\n                Opdater\n            ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-242b0c66"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/components/user.vue
// module id = 824
// module chunks = 0